export default __webpack_public_path__ + "static/media/logo.8b06a91b.png";